// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { EventEmitter, OnInit } from '@angular/core';
var SelectableActionTableComponent = /** @class */ (function () {
    function SelectableActionTableComponent() {
        this._selected = [];
        this.currentPageNumber = 0;
        this.selected = [];
        this.actions = undefined;
        this.selectActions = new EventEmitter();
    }
    SelectableActionTableComponent.prototype.ngOnInit = function () { };
    SelectableActionTableComponent.prototype.rowIdentity = function (row) {
        return row.id;
    };
    SelectableActionTableComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        this.clearSelected();
        (_b = this._selected).push.apply(_b, selected);
        this.selectActions.emit(this._selected);
        var _b;
    };
    SelectableActionTableComponent.prototype.clearSelected = function () {
        this._selected.splice(0, this._selected.length);
    };
    SelectableActionTableComponent.prototype.filterList = function (text) {
        if (text === void 0) { text = ''; }
        var searchValue = text.toLowerCase();
        this.filteredList = this.actions
            ? this.actions.filter(function (item) {
                return JSON.stringify(item)
                    .toLowerCase()
                    .includes(searchValue) || !searchValue;
            })
            : [];
    };
    return SelectableActionTableComponent;
}());
export { SelectableActionTableComponent };



// WEBPACK FOOTER //
// ./src/app/access-management/selectable-action-table/selectable-action-table.component.ts.pre-build-optimizer.js